var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "FlyerlineModal",
        { staticClass: "flyerline-modal--small", attrs: { name: _vm.name } },
        [
          _c("div", [
            _c(
              "div",
              { attrs: { hidden: _vm.hide } },
              [
                _c("h3", { staticClass: "text-shade-darker" }, [
                  _vm._v(_vm._s(_vm._f("translate")("txtSendOffer"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-small mb-prj2" }, [
                  _vm._v(_vm._s(_vm._f("translate")("txtSendOfferHelpText"))),
                ]),
                _vm._v(" "),
                _c("SkyFormLoader", {
                  staticClass: "label--small",
                  attrs: { "form-name": "prj_productoffer" },
                  on: {
                    success: _vm.handleSuccess,
                    beforeSubmit: _vm.handleBeforeSubmit,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { attrs: { hidden: !_vm.hide } }, [
              _c("div", { staticClass: "d-flex p-2 line-height-14" }, [
                _c(
                  "svg",
                  {
                    staticClass:
                      "mr-2 svg-icon flex-child-fix position-relative t-2px",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      x: "0",
                      y: "0",
                      viewBox: "0 0 36 36",
                      "xml:space": "preserve",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M36 18.01c0 9.94-8.04 17.98-17.99 17.99C8.03 36.01-.01 27.95 0 17.93 0 8.04 8.09-.01 18.02 0 27.96.01 36 8.06 36 18.01z",
                        fill: "#62b982",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        id: "XMLID_1_",
                        d: "M14.93 26.67l-6.46-6.46a2.07 2.07 0 010-2.93 2.07 2.07 0 012.93 0l3.55 3.55 9.66-9.56c.81-.8 2.12-.8 2.93.02.8.81.8 2.12-.02 2.93L14.93 26.67z",
                        fill: "#fff",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "h3",
                    {
                      staticClass:
                        "text-shade-darker mb-0 position-relative tn-1px",
                    },
                    [_vm._v(_vm._s(_vm._f("translate")("txtSendOfferSended")))]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(
                      _vm._s(_vm._f("translate")("txtSendOfferSuccessful"))
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm._t("default", null, { open: _vm.open }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }